import state from './modulePersonListState.js'
import mutations from './modulePersonListMutations.js'
import actions from './modulePersonListActions.js'
import getters from './modulePersonListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

